// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".color-button-view[data-v-4b6e8c80]{width:80px}.contact-lens-color-icon[data-v-4b6e8c80]{width:60px;height:60px}", ""]);
// Exports
module.exports = exports;
